<template>
	<div
		class="checkbox"
		:class="{
			'is-disabled': disabled,
			'-t-dark': darkTheme,
			'-no-label': !label,
		}"
	>
		<input
			:id="id"
			v-model="internalValue"
			class="checkbox__input"
			type="checkbox"
			@change="handleChange"
		>
		<label
			:for="id"
			class="checkbox__label"
			:class="{
				'-t-dark': darkTheme,
			}"
		>
			<div
				v-if="label"
				class="checkbox__label-inner"
				v-html="label"
			/>
		</label>
	</div>
</template>

<script>
export default {
	name:  'InputCheckbox',
	props: {
		id: {
			type:    [Number, String],
			default: '',
		},
		label: {
			type:    String,
			default: '',
		},
		value: {
			type: Boolean,
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		darkTheme: { // not fully implemented, needs some more work
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {
			internalValue: false,
		};
	},
	watch: {
		value(value) {
			this.internalValue = value;
		},
	},
	mounted() {
		this.internalValue = this.value;
	},
	methods: {
		handleChange(event) {
			const value = event.target.checked;
			this.$emit('input', value);
			this.$emit('change', value);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.checkbox {
	position: relative;
	margin-bottom: $form-margin-bottom;
	min-height: 24px;

	&.-no-label {
		margin-bottom: 0;
	}
}

.checkbox__input {
	position: absolute;
	opacity: 0;

	.checkbox.is-disabled & {
		pointer-events: none;
	}
}

.checkbox__label {
	$square-size: 16px;

	display: flex;
	align-items: center;
	position: relative;
	padding-left: $sp5;
	user-select: none;
	min-height: $square-size;

	&::before,
	&::after {
		content: '';
		display: block;
		position: absolute;
		top: 9px;
		left: 0;
		transform: translateY(-50%);
		width: $square-size;
		height: $square-size;
	}

	&::before {
		border: 1px solid var(--color-grey-300);
	}

	&::after {
		color: var(--color-white);
	}

	.checkbox.-no-label & {
		padding-left: 0;
	}

	&.-t-dark::before {
		border: 1px solid var(--color-white);
		background-color: transparent;
	}

	.checkbox__input:checked + & {
		&.-t-dark::after {
			background-color: var(--color-hype-yellow);
		}

		&::after {
			background-color: var(--color-green-petrol);
			color: var(--color-white);
			background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="%23FFF"/></svg>');
		}

		.checkbox.is-disabled & { // stylelint-disable-line max-nesting-depth
			&::after { // stylelint-disable-line max-nesting-depth
				background-color: $form-color-input-text-disabled;
			}
		}
	}

	.checkbox__input:checked + & {
		&.-t-dark::before {
			border: 1px solid var(--color-hype-yellow);
		}
	}

	.checkbox.is-disabled & {
		pointer-events: none;
		color: $form-color-input-text-disabled;

		&::before {
			border-color: $form-color-input-text-disabled;
		}

		&::after {
			background-color: $form-color-bg-disabled;
		}
	}

	.checkbox.-t-dark & {
		color: var(--color-white);
	}

	&:hover {
		cursor: pointer;

		&::before {
			border-color: var(--color-grey-500);
		}
	}
}

.checkbox__label-inner::v-deep {
	a { // stylelint-disable-line
		text-decoration: underline;
	}
}
</style>
